import * as yup from 'yup';
import { TFunction } from 'i18next';
import { DateOnly } from '../../utility';
import { ISpecialPackageReservationDto } from '../ISpecialPackageReservationDto';

export function specialPackageReservationDtoValidation(
  translation: TFunction<'translation', undefined>
): yup.ObjectSchema<ISpecialPackageReservationDto> {
  return yup
    .object({
      specialPackageRoomCategoryId: yup
        .number()
        .typeError(translation('errors.required'))
        .required(translation('errors.required'))
        .defined()
        .nonNullable(),
      occupancy: yup
        .number()
        .typeError(translation('errors.required'))
        .required(translation('errors.required'))
        .oneOf([1, 2], translation('errors.required'))
        .defined()
        .nonNullable(),

      contactBirthday: yup
        .date()
        .transform((e) => (e ? new DateOnly(e) : null))
        .nullable()
        .defined(),
      contactLanguage: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),
      contactMail: yup
        .string()
        .trim()
        .email(translation('errors.required'))
        .required(translation('errors.required')),
      contactPhone: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .matches(/^\+[1-9]\d{1,14}$/, 'Format must be +4... without spaces')
        .nullable()
        .defined(),
      contactTitle: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .nullable()
        .defined(),
      contactFirstname: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),
      contactLastname: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),

      contactStreet: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),
      contactStreetNr: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),
      contactPostal: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),
      contactCity: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),
      contactCountry: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .required(translation('errors.required')),

      agbAccepted: yup.bool().required().oneOf([true]),
      privacyPolicyAccepted: yup.bool().required().oneOf([true]),
      newsletter: yup.bool().required(),

      message: yup
        .string()
        .trim()
        .transform((e) => (e === '' ? null : e))
        .nullable()
        .defined(),
    })
    .required();
}
